import type { FC } from 'react';

import type { MultiSelectFilterValue } from '@iconik-io/shared-lib/src/redux/common_filters/types';

import type { FormFieldEvent } from '../../types';
import { MultiSelectFilterFieldWrapper } from '../multi_select_filter_field/multi_select_filter_field_wrapper';
import { usePersonFilterOptions } from '../multi_select_filter_field/option_hooks';

type Props = {
  name: string;
  value?: MultiSelectFilterValue;
  onChange?: (
    value: MultiSelectFilterValue | undefined,
    event?: FormFieldEvent,
  ) => void;
  label?: string;
  subtitle?: string;
  vertical?: boolean;
  disabled?: boolean;
};

export const MultiSelectFilterPersonField: FC<Props> = (props) => {
  const options = usePersonFilterOptions();

  return (
    <MultiSelectFilterFieldWrapper
      {...props}
      loadOptions={options.loadOptions}
      resolveSelectedItems={options.resolveSelectedItems}
      itemLabels={options.itemLabels}
    />
  );
};
